import React, { Component } from 'react'
import { withSettings } from '../withSettings'
import Form from '../Form'
import Swatch from './Swatch'
import SwatchGroup from './SwatchGroup'
import merge from 'lodash/merge'
import uniqueId from 'lodash/uniqueId'
import pick from 'lodash/pick'
import Icon from '../../../../util/Icon'

const defaults = {
  widget: {
    background: 'rgb(255, 255, 255)',
    fontFamily: "Helvetica Neue', 'Roboto', 'Helvetica', 'Arial', sans-serif",
    color: 'rgb(85, 88, 99)'
  },
  headings: {
    fontFamily: "Helvetica Neue', 'Roboto', 'Helvetica', 'Arial', sans-serif",
    color: 'rgb(85, 88, 99)'
  },
  anchors: {
    color: 'rgb(34, 143, 204)'
  },
  buttons: {
    search: {
      basic: {
        background: 'rgb(85, 88, 99)',
        color: 'rgb(233, 239, 242)'
      }
    },
    cta: {
      background: 'rgb(34, 143, 204)',
      color: 'rgb(249, 250, 251)'
    }
  },
  results: {
    actionsMenu: {
      background: 'rgb(34, 143, 204)',
      color: 'rgb(249, 250, 251)',
    }
  }
}

@withSettings
export default class DesignSettings extends Component {

  state = {
    clearForm: uniqueId()
  }

  handleData = data => this.props.setSettingsAt('design', data)

  factoryReset = () => {
    const confirmed = confirm('Are you sure you want to reset all your design settings?')
    if (!confirmed) return
    this.props.setSettingsAt('design', defaults).then(() => {
      this.setState({ clearForm: uniqueId() })
    })
  }

  render() {
    const design = merge({}, defaults, this.props.getSettingsAt('design'))
    return (
      <div className="container padded settings">
        <Form onData={this.handleData} key={this.state.clearForm}>
          <div className="panel padded">
            <h2 className="title">Design Settings</h2>
            <div className="form-section">
              <label>Plugin Background</label>
              <p className="muted">
                Customize the plugin background color and opacity
              </p>
              <Swatch
                name="widget[background]"
                defaultColor={design.widget.background} />
            </div>

            <div className="form-section">
              <label>Body Font</label>
              <p className="muted">
                Customize the default font family and color
              </p>
              <SwatchGroup
                prefix="widget"
                swatches={pick(design.widget, 'fontFamily', 'color')}>
                <p className="example">
                  The quick brown fox jumps over the lazy dog.
                </p>
              </SwatchGroup>
            </div>

            <div className="form-section">
              <label>Heading Font</label>
              <p className="muted">
                Customize the heading font family and color
              </p>
              <SwatchGroup
                prefix="headings"
                swatches={design.headings}>
                <h3 className="example">
                  The quick brown fox jumps over the lazy dog.
                </h3>
              </SwatchGroup>
            </div>

            <div className="form-section">
              <label>Price / Beds / Bath / Type Search Form Buttons</label>
              <p className="muted">
                Customize the look of primary search buttons
              </p>
              <SwatchGroup
                prefix="buttons[search][basic]"
                swatches={design.buttons.search.basic}>
                <button type="button" className="example">
                  Example
                </button>
              </SwatchGroup>
            </div>

            <div className="form-section">
              <label>Call To Action Buttons</label>
              <p className="muted">
                Customize the look of call to action buttons
              </p>
              <SwatchGroup
                prefix="buttons[cta]"
                swatches={design.buttons.cta}>
                <button type="button" className="example">
                  Example
                </button>
              </SwatchGroup>
            </div>

            <div className="form-section">
              <label>Search Results Actions Menu</label>
              <p className="muted">
                Customize the look of the action menu in search results
              </p>
              <SwatchGroup
                prefix="results[actionsMenu]"
                swatches={design.results.actionsMenu}>
                <button type="button" className="example actions-menu-example">
                  <Icon icon="star-o" />
                  <Icon icon="smile-o" />
                  <Icon icon="comments" />
                  <Icon icon="share" />
                  <Icon icon="times" />
                </button>
              </SwatchGroup>
            </div>

            <div className="form-section">
              <label>Link Color</label>
              <p className="muted">
                Customize the color of text links
              </p>
              <Swatch
                name="anchors[color]"
                defaultColor={design.anchors.color} />
            </div>

            <div className="form-section">
              <label>Custom CSS</label>
              <p className="muted">
                For Advanced Users: Put CSS in this box to override very specific CSS classes.
              </p>
              <textarea
                style={{width: '100%', minHeight: 200, fontFamily: 'monospace'}}
                name="custom_css"
                defaultValue={design.custom_css} />
            </div>
          </div>

          <div className="panel padded caution">
            <p className="muted" style={{textAlign: 'center', margin: 0}}>You will need to clear your cache to see any changes.</p>
          </div>

          <button type="submit" className="big shadowed">Save Changes</button>

          <div className="panel padded danger">
            <button type="button" className="big shadowed danger" onClick={this.factoryReset}>Reset to Showcase Defaults</button>
            <p className="muted" style={{textAlign: 'center', margin: 0}}>Reset all fields to design defaults including custom css.</p>
          </div>
        </Form>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// client/components/sections/website/settings/Design/index.js